import { render } from "./TicketActionSecondaryButton.vue?vue&type=template&id=f4cf60c6"
import script from "./TicketActionSecondaryButton.vue?vue&type=script&lang=js"
export * from "./TicketActionSecondaryButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__